import MetricBase from "models/metrics/MetricBase";
import ConnectivityGroup from "models/groups/ConnectivityGroup";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import i18n from "i18next";

class MetricNoLandingPageCount extends MetricBase {
    constructor() {
        super({
            field: "metric_noLandingPageCount",
            defaultVisibility: true,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.google_hotel_ads.noLandingPageCount.chartName"),
            serieLabel: i18n.t("metrics.google_hotel_ads.noLandingPageCount.serieLabel"),
            tooltip: i18n.t("metrics.google_hotel_ads.noLandingPageCount.tooltip"),
            group: new ConnectivityGroup(),
        });
    }
}

export default MetricNoLandingPageCount;
